import React from 'react';
import PropTypes from 'prop-types';
import { Table, Tag, Tooltip, Progress, Popover, Button, Divider, Popconfirm } from 'antd';
import { PhoneOutlined, MailOutlined, ContainerOutlined, AndroidOutlined, AppleOutlined, ChromeOutlined } from '@ant-design/icons';
import { RESERVE_STATE, PLATFORMS } from './../../constants/reserve';
import './styles.css';

const { Column } = Table;



const ReservationsTable = ({ data, onActionSelected, onShowReservation }) => {

    const getColorTagType = type => {   
        switch (type) {
            case RESERVE_STATE.accepted:
                return 'geekblue';
            case RESERVE_STATE.pending:
                return 'purple';
            case RESERVE_STATE.cancelled:
                return 'volcano';
            case RESERVE_STATE.assisted:
                return 'green';
            case RESERVE_STATE.no_assisted:
                return 'red';
            case RESERVE_STATE.rejected:
                return 'magenta';
            default:
                return;
        }
    };

    const getTagName = type => {   
        switch (type) {
            case RESERVE_STATE.accepted:
                return 'ACEPTADA';
            case RESERVE_STATE.pending:
                return 'PENDIENTE';
            case RESERVE_STATE.cancelled:
                return 'CANCELADA';
            case RESERVE_STATE.assisted:
                return 'ASISTIDA';
            case RESERVE_STATE.no_assisted:
                return 'NO ASISTIDA';
            case RESERVE_STATE.rejected:
                return 'RECHAZADA';
            default:
                return;
        }
    };

    const renderAction = (state, id) => {
        var content;
        switch (state) {
            case RESERVE_STATE.accepted:
                content = (
                    <div className="accionCont">
                        <Popconfirm title="¿Desea 'rechazar' la reserva?" okText="SI" cancelText="NO" onConfirm={() => onActionSelected(state, RESERVE_STATE.rejected, id)}>
                            <Button>Rechazar</Button>
                        </Popconfirm>
                    </div>
                );
                return (
                <Popover content={content}>
                    <Button type="primary">Acción</Button>
                </Popover>);
            case RESERVE_STATE.pending:
                content = (
                    <div className="accionCont">
                        <Popconfirm title="¿Desea 'aceptar' la reserva?" okText="SI" cancelText="NO" onConfirm={() => onActionSelected(state, RESERVE_STATE.accepted, id)}>
                            <Button>Aceptar</Button>
                        </Popconfirm>
                        <Divider type="vertical" />
                        <Popconfirm title="¿Desea 'rechazar' la reserva?" okText="SI" cancelText="NO" onConfirm={() => onActionSelected(state, RESERVE_STATE.rejected, id)}>
                            <Button>Rechazar</Button>
                        </Popconfirm>
                    </div>
                );
                return (
                <Popover content={content}>
                    <Button type="primary">Acción</Button>
                </Popover>);
            default:
                return;
        }
    }

    const renderPlatformIcon = platform => {
        switch (platform) {
            case PLATFORMS.ANDROID:
                return(<Tooltip title="Android">
                    <AndroidOutlined style={{ fontSize: '22px' }}/>
                </Tooltip>)
            case PLATFORMS.IOS:
                return(<Tooltip title="iOS">
                    <AppleOutlined style={{ fontSize: '22px' }}/>
                </Tooltip>)
            case PLATFORMS.WEB:
                return(<Tooltip title="web">
                    <ChromeOutlined style={{ fontSize: '22px' }}/>
                </Tooltip>)
            default:
                return(<Tooltip title="Android">
                    <AndroidOutlined />
                </Tooltip>)
        }
    }

    return (
        <Table className="reservationsTableCont" dataSource={data} rowKey="id" size="small" pagination={false}>
            <Column className="detailsCont" title="Ver" dataIndex="details" key="details" align="center" 
                render={(text, record) => {
                    return (
                    <Tooltip title="Ver">
                        <Button onClick={() => onShowReservation(record.id)} type="primary" icon={<ContainerOutlined />} size="middle" />
                    </Tooltip>);
                }}
            />
            <Column className="hourCont" title="Hora" dataIndex="hour" key="hour" align="center" />
            <Column className="platformCont" title="Plat." dataIndex="platform" key="platform" align="center" 
            render={(text, record) => {
                return (
                <span>
                    {renderPlatformIcon(record.platform)}
                </span>);
            }}/>
            <Column className="peopleCountCont" title="Cantidad de personas | Descuento" dataIndex="peopleCount" key="peopleCount" align="center"
                render={(text, record) => {
                    return (
                    <span>
                        {record.peopleCount}{(record.discount && record.discount !== "0") ? <span><Divider type="vertical" /><Tag color={"purple"}>%{record.discount}</Tag></span> : ""}
                    </span>);
                }}
            />
            <Column className="nameCont" title="Usuario" dataIndex="name" key="name" align="center" 
            render={(text, record) => {
                    return (
                    <div>
                        {record.name}
                        <Popover content={
                            <div>
                                {
                                    record.phone && record.phone !== "" ?
                                        <p>Teléfono: {record.phone}</p>
                                        :
                                        <p>No hay teléfono registrado</p>
                                }
                            </div>
                        }>
                            <PhoneOutlined />
                        </Popover>
                        <Divider type="vertical" />
                        <Popover content={
                            <div>
                                {
                                    record.email && record.email !== "" ?
                                        <p>Correo electrónico: {record.email}</p>
                                        :
                                        <p>No hay correo electrónico registrado</p>
                                }
                            </div>
                        }>
                            <MailOutlined />
                        </Popover>
                    </div>);
                }}/>
            {/*<Column title="Puntuación" dataIndex="rating" key="rating" align="center"
                render={rating => {
                    return(
                    <span>
                        <Rate disabled allowHalf defaultValue={0} value={rating} style={{ fontSize: 16 }} />
                    </span>);
                }}
            />*/}
            <Column title="Reservas asistidas" dataIndex="reservations" key="reservations" align="center"
                render={reservations => {
                    const percent = Math.floor((reservations.assistedReservationsCount / reservations.totalReservationsCount) * 100);
                    return (
                    <span>
                        <Tooltip title={reservations.assistedReservationsCount + " de " + reservations.totalReservationsCount}>
                            <Progress percent={percent} type="circle" width={50} strokeColor="#94509b" format={percent => `${percent}%`} />
                        </Tooltip>
                    </span>);
                }}
            />
            <Column title="Reservas canceladas" dataIndex="reservations" key="reservationsCancelled" align="center"
                render={reservations => {
                    const percent = Math.floor((reservations.cancelledReservationsCount / reservations.totalReservationsCount) * 100);
                    return (<span>
                        <Tooltip title={reservations.cancelledReservationsCount + " de " + reservations.totalReservationsCount}>
                            <Progress percent={percent} type="circle" width={50} strokeColor="red" format={percent => `${percent}%`} />
                        </Tooltip>
                    </span>);
                }}
            />
            <Column title="Lugares ocupados" dataIndex="placesOccupied" key="placesOccupied" align="center"
                render={placesOccupied => {
                    const percent = Math.floor((placesOccupied.occupied / placesOccupied.total) * 100);
                    return (<span>
                        <Tooltip title={placesOccupied.occupied + " de " + placesOccupied.total}>
                            <Progress percent={percent} type="circle" width={50} strokeColor="blue" format={percent => `${percent}%`} />
                        </Tooltip>
                    </span>);
                }}
            />
            <Column title="Estado" dataIndex="state" key="state" align="center"
                render={state => (
                    <span>
                        {<Tag color={getColorTagType(state)} key={state}>
                            {getTagName(state)}
                        </Tag>}
                    </span>
                )}
            />
            <Column title="Acción" dataIndex="state" key="action" align="center"
                render={(text, record) => (
                    <span>
                        {
                            record.isLoading ?
                                <Button type="primary" disabled={true} loading>
                                    Cargando
                                </Button>
                                :
                                renderAction(record.state, record.id)
                        }
                    </span>
                )}
            />
        </Table>
    );
};

ReservationsTable.propTypes = {
    data: PropTypes.array.isRequired,
    onActionSelected: PropTypes.func.isRequired,
    /*data: PropTypes.shape({
        hour: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        averageReservationTime: PropTypes.number.isRequired,
        state: PropTypes.string.isRequired,
    }),*/
};

export default ReservationsTable;